import { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";

export type DialogProps = {
  className?: string;
  children?: ReactNode | ReactNode[];
  onClose: () => void;
  open: boolean;
};

export function Dialog({ open, onClose, children, className }: DialogProps) {
  useEffect(() => {
    if (open && !document.body.classList.contains("overflow-hidden")) {
      document.body.classList.add("overflow-hidden");
      return () => document.body.classList.remove("overflow-hidden");
    }

    return () => null;
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-[rgba(0,_0,_0,_0.5)] z-[1000] overflow-hidden"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`fixed top-4 left-4 md:left-auto bottom-4 md:bottom-auto md:top-1/2 right-4 md:right-1/2 md:translate-x-[50%] md:-translate-y-[50%] bg-white z-[1001] rounded-3xl md:max-h-[85%] ${className} overflow-auto`}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export function AutoHeightDialog({
  open,
  onClose,
  children,
  className,
}: DialogProps) {
  useEffect(() => {
    if (open && !document.body.classList.contains("overflow-hidden")) {
      document.body.classList.add("overflow-hidden");
      return () => document.body.classList.remove("overflow-hidden");
    }

    return () => null;
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-[rgba(0,_0,_0,_0.5)] z-[1000] overflow-hidden"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`${className} fixed left-4 md:left-auto top-1/2 right-4 md:right-1/2 md:translate-x-[50%] md:-translate-y-[50%] bg-white z-[1001] rounded-3xl md:max-h-[85%] overflow-auto`}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
